import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const variantStyles = {
    primary: `
    background: var(--color-accent-primary);
    color: var(--color-bg-base);
    border: none;
  `,
    secondary: `
    background: transparent;
    color: var(--color-text);
    border: 1px solid var(--color-border-bright);
  `,
    quiet: `
    background: transparent;
    color: var(--color-text-muted);
    border: none;
  `,
    destructive: `
    background: transparent;
    color: var(--color-danger);
    border: 1px solid var(--color-danger);
  `,
};
const sizeStyles = {
    sm: 'height: 32px; padding: 0 12px; font-size: var(--text-caption);',
    md: 'height: 40px; padding: 0 16px; font-size: var(--text-body);',
    lg: 'height: 48px; padding: 0 24px; font-size: var(--text-body);',
};
export function Button({ variant = 'secondary', size = 'md', loading = false, disabled, children, style, ...props }) {
    const baseStyle = `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    border-radius: var(--radius-md);
    font-family: var(--font-body);
    font-weight: 500;
    cursor: pointer;
    transition: all var(--duration-normal) var(--easing-default);
    white-space: nowrap;
    user-select: none;
    ${variantStyles[variant]}
    ${sizeStyles[size]}
    ${disabled || loading ? 'opacity: 0.5; pointer-events: none;' : ''}
  `;
    return (_jsxs("button", { disabled: disabled || loading, style: { ...parseInlineStyle(baseStyle), ...style }, ...props, children: [loading && _jsx(Spinner, {}), children] }));
}
function Spinner() {
    return (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", style: { animation: 'spin 1s linear infinite' }, "aria-hidden": "true", children: [_jsx("circle", { cx: "8", cy: "8", r: "6", stroke: "currentColor", strokeWidth: "2", opacity: "0.25" }), _jsx("path", { d: "M8 2a6 6 0 0 1 6 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })] }));
}
function parseInlineStyle(css) {
    const style = {};
    css.split(';').forEach((rule) => {
        const [prop, val] = rule.split(':').map((s) => s.trim());
        if (prop && val) {
            const camelProp = prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
            style[camelProp] = val;
        }
    });
    return style;
}
//# sourceMappingURL=Button.js.map